export default __webpack_public_path__ + "static/media/team86.793c7d51.JPG";